import { extendTheme } from "@chakra-ui/react";

const theme = extendTheme({
  components: {
    Button: { 
      variants: {
        'primary': {
          bg: 'blue.200',
          color: 'white',
          borderRadius: '2px',
          _hover:{
            filter: "brightness(.9)",
          },
        },
        secondary: {
          bg: "transparent",
          color: "black",
          borderRadius: "2px",
          border: "1px solid",
          borderColor: " #D9D9D9",
          transition: "background 0.4s ease",
          _hover: {
            bg: "#e3e5e8"
          }
        },
        'login': {
          bg: 'blue.200',
          color: 'white',
          borderRadius: '2px',
          _hover:{
            filter: "brightness(.9)",
            _disabled: {
              filter: "brightness(1)",
              bg: 'neutral.400',
            }
          },
          _disabled: {
            bg: 'neutral.400',
            color: 'rgba(0, 0, 0, 0.50)',
            border: '1px solid #D9D9D9',
          }
        },
        cancel: {
          bg: "transparent",
          color: "#FF4D4F",
          borderRadius: "2px",
          border: "1px solid",
          borderColor: " #FF4D4F",
          fontWeight: 400,
          transition: "background 0.4s ease",
          _hover: {
            bg: "#ffbaba",
          },
        },
      },
    },
    Badge: {
      baseStyle: {
        textTransform: "none",
        fontWeight: 400,
      },
      variants: {
        blue: {
          bg: "rgba(8, 55, 145, 0.15)",
          color: "blue.400",
          p: "0 0.5rem",
        },
        gray: {
          bg: "#E6E9F0",
          color: "#3D485C",
          p: "0 0.5rem",
        },
        green: {
          bg: "rgba(44, 196, 82, 0.1)",
          color: "green.400",
          p: "0 0.5rem",
        },
        lightgreen: {
          bg: "rgba(193, 211, 205, 0.5)",
          color: "green.400",
          p: "0 0.5rem",
        },
        yellow: {
          bg: "rgba(240, 188, 3, 0.1)",
          color: "yellow.dark",
        },
        red: {
          bg: "rgba(196, 44, 44, 0.1)",
          color: "red.700",
          p: "0 0.5rem",
        },
        lightred: {
          bg: "rgba(255, 68, 68, 0.1)",
          color: "#3D485C",
          p: "0 0.5rem",
        },
        volcano: {
          bg: "volcano",
          color: "orange.10",
          p: "0 0.5rem",
        },
        yellowDark: {
          bg: "#FFE7BA",
          color: "#3D485C",
          p: "0 0.5rem",
        },
        
      },
    },
  },
  colors: {
    gray: {
      login: "#262F40",
      "25": "#F5F7FA",
      "30": "#EDF1F7",
      "50": "#dfe3ec",
      "90": "#E6E9F0",
      "100": "#e3e5e8",
      "200": "#c8cbd2",
      "300": "#aab0bb",
      "400": "#8d95a5",
      "500": "#707b8f",
      "600": "#5a6272",
      "700": "#434a56",
      "800": "#262F40",
      "900": "#16181d",
    },
    neutral: {
      "100": "#eeeeee",
      "200": "#D9D9D9",
      "300": "#cccccc",
      "400": "#F5F5F5",
      "600": "#888888",
      "700": "#666666",
      "800": "#282828",
      "900": "#000000",
    },
    polargreen: {
      "100": "#F6FFED",
      "300": "#B7EB8F",
      "600": "#52C41A"
    },
    dustred: {
      "100": "#FFF1F0",
      "200": "#FFCCC7",
      "500": "#FF4D4F",
    },
    black: {
      900: "#000000",
    },
    white: "#ffffff",
    red: {
      700: "#8E1E1E",
    },
    cobrancaP: {
      700: "#1890FF",
    },
    bgRow: "#f5f5f6",
    success: "#1cedba",
    danger: "#d33939",
    magenta: "#dd057c",
    blue: {
      100: "#4cbfed",
      200: "#1890FF",
    },
    gold: {
      500: "#FAAD14",
    },
    pink: {
      50: "#FAE9EE",
      100: "#C21776",
      200: "#CB2159",
    },
  },
  fonts: {
    heading: "Hero New",
    body: "Hero New",
  },
  styles: {
    global: {
      body: {
        bg: "white",
        color: "gray.600",
        a: {
          color: "#6F7B90",
          _hover: {
            color: "#000",
          },
        },
        table: {
          svg: {
            color: "#6F7B90",
            _hover: {
              color: "#000",
            },
          },
        },
      },
    },
  },
});

export { theme };